import {Component, NgZone, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {GoogleAnalyticsService} from 'src/app/services/google-analytics.service';
import {NotificationsService} from 'angular2-notifications';
import {GenericValidator} from 'src/app/generic-validator';
import {PaymentService} from 'src/app/services/payment.service';
import {CardFlagType, Pagamento} from 'src/app/model/pagamento.model';
import {NovoPagamento} from 'src/app/model/novopagamento.model';
import {Mask} from 'src/app/model/mask.model';
import {Result} from 'src/app/model/result.model';
import {Usuario} from 'src/app/model/usuario.model';
import {first} from 'rxjs/operators';
import creditCardType from 'credit-card-type';
import {CustomSiteService} from '../../services/customsite.service';
import {ConfigurationService} from '../../services/configuration.service';

@Component({
  selector: 'app-pagamento',
  templateUrl: './pagamento.component.html',
  styleUrls: ['./pagamento.component.css']
})
export class PagamentoComponent implements OnInit {
    cpfmask = Mask.cpf;
    showSpinner = false;
    model: any = {};
    user: Usuario;
    resultado: Result;
    erro = false;
    dadosPagamento: any = {};
    cardFlagName: String;
  pageTitle = "Atendimento - Pagmob";

    constructor(private paymentService: PaymentService, private zone: NgZone, private router: Router, private _notificationService: NotificationsService, public googleAnalyticsService: GoogleAnalyticsService, private customSiteService: CustomSiteService,
                private configService: ConfigurationService) { }

    ngOnInit() {
        this.googleAnalyticsService.eventEmitter("pagamento", "load", "page-load", 1);

        this.user = <Usuario>JSON.parse(localStorage.getItem('usuario'));

        this.dadosPagamento = JSON.parse(localStorage.getItem('dadosPagamento'));

        this.model = new NovoPagamento();
        this.model.userEmail = this.user.email;
        this.model.pagamento = new Pagamento();

        this.dadosPagamento.valueToPayFormatted = this.dadosPagamento.agendamento.valueOfService.toFixed(2);
        this.dadosPagamento.shippingFeeFormatted = this.dadosPagamento.agendamento.shippingValue.toFixed(2);
        this.dadosPagamento.totalValue = this.dadosPagamento.agendamento.valueOfService;
        if (this.dadosPagamento.agendamento.shippingValue != null) {
            this.dadosPagamento.totalValue += this.dadosPagamento.agendamento.shippingValue;
            this.model.pagamento.additionalValue = this.dadosPagamento.agendamento.shippingValue;
        }
        this.dadosPagamento.totalValueFormatted = this.dadosPagamento.totalValue.toFixed(2);
      const pageTitle = sessionStorage.getItem("pageTitle");
      if(pageTitle == null)
        this.configService.loadConfigurations().subscribe(config => {
          this.customSiteService.login(config.agencyId).subscribe(customsite => {
            if(customsite.pageTitle) {
              this.pageTitle = customsite.pageTitle;
              sessionStorage.setItem("pageTitle",this.pageTitle);
            }
            if(customsite.pageTitle) sessionStorage.setItem("loginText", customsite.loginText);
            if(customsite.loginObs) sessionStorage.setItem("loginObs", customsite.loginObs);
            if(customsite.popUp) sessionStorage.setItem("popUp", customsite.popUp);
            if(customsite.privacy) sessionStorage.setItem("privacy", customsite.privacy);
            if(customsite.termsAcceptance) sessionStorage.setItem("termsAcceptance", customsite.termsAcceptance);
            if(customsite.register) sessionStorage.setItem("register", customsite.register);
          });
        });
      else {
        this.pageTitle = pageTitle;
      }
    }

    pagar() {
        this.googleAnalyticsService.eventEmitter("pagamento", "button-click", "novo-pagamento", 2);
        this.model.pagamento.cardholdercpf = this.model.pagamento.cardholdercpf.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
        this.model.pagamento.cardholdercpf = this.model.pagamento.cardholdercpf.replace('-', '');

        if (!GenericValidator.isValidCpf(this.model.pagamento.cardholdercpf)) {
            this._notificationService.error('CPF', 'CPF inválido.');
            return;
        }

        this.showSpinner = true;
        this.paymentService.postPagamento(this.user.userId, this.dadosPagamento.agenciaId, Number(this.dadosPagamento.agendamento.protocol), this.model).pipe(first()).subscribe((result: Result) => {
            this.showSpinner = false;
            var toast: any;
            if (result.success) {
                toast = this._notificationService.success('Pagamento', 'Pagamento efetuado com sucesso.');
                this.googleAnalyticsService.eventEmitter("pagamento", "button-click", "sucesso", 3);

                toast.timeoutEnd.pipe(first()).subscribe(() => {
                this.zone.run(() => {
                        this.router.navigate(['app/dashboard']);
                    });
                });
            } else {
                toast = this._notificationService.error('Pagamento', 'Não foi possível realizar seu pagamento. Verifique os dados do cartão e tente novamente.');
                this.googleAnalyticsService.eventEmitter("pagamento", "button-click", "erro_negocio", 5);
            }

        }, (err) => {
            this.showSpinner = false;
            this.erro = true;
            this.resultado= err;
            this.googleAnalyticsService.eventEmitter("pagamento", "button-click", "erro", 4);
        });
    }

    checkCardFlag ( cardNumber: String ) {
        let possibleCardFlags = creditCardType( cardNumber );

        if ( possibleCardFlags.length === 1 ) {
            this.cardFlagName = possibleCardFlags[ 0 ].type;
            switch( this.cardFlagName ) {
                case "visa":
                    this.model.pagamento.cardflag = CardFlagType.VISA;
                    break;
                case "mastercard": case "maestro":
                    this.model.pagamento.cardflag = CardFlagType.MASTER;
                    break;
                case "elo":
                    this.model.pagamento.cardflag = CardFlagType.ELO;
                    break;
                default:
                    this.model.pagamento.cardflag = null;
                    this.cardFlagName = null;
            }
        } else {
            this.model.pagamento.cardflag = null;
            this.cardFlagName = null;
        }
    }

}
